<template>
  <collapse class="date" title="Dates" :defaultCollapse="false">
    <el-date-picker
      v-model="dates"
      type="daterange"
      range-separator="à"
      start-placeholder="Date de début"
      end-placeholder="Date de fin"
      size="mini"
      align="left"
      firstDayOfWeek="1">
    </el-date-picker>
  </collapse>
</template>

<script>
import Collapse from '@/components/tools/collapse/Collapse'

export default {
  name: 'SportGamesFiltersDay',
  components: { Collapse },
  props: {
    dateStart: Date,
    dateEnd: Date
  },
  data () {
    return {
      values: [this.dateStart, this.dateEnd]
    }
  },
  computed: {
    dates: {
      get () { return this.values },
      set (values) {
        this.values = values
        this.$emit('change', values)
      }
    }
  }
}
</script>

<style scoped>
  .date > .content > .el-date-editor--daterange.el-input__inner{
    width:auto
  }
</style>
